import categoriesBanner from "./CategoriesBanner.png";
import ourMissionImg from "./ourMissionImg.png";
import ourMissionmMobileImg from "./ourMissionmMobileImg.png";
import OriginativeImg from "./Originative about unique ideas.png";
import CategoriesBannerImg from "./CategoriesBanner.png";
import gemlogoImg from "./gemlogo_img.png";
import bestQualityImg from "./bestQuality_img.png";
import userDashBoradBannerImg from "./userDashBoradBannerImg_1.png";
import userDashBoradBanner2Img from "./userDashBoradBannerImg_2.png";
import userDashBoradBanner3Img from "./userDashBoradBannerImg_3.png";
import talentBgImg1 from "./talent_bg_image.png";
import talentBgImg2 from "./talent_bg2_image.png";
import talentBgImg3 from "./talent_bg3_image.png";
import talentBgImg4 from "./talent_bg4_image.png";
import talentBgImg5 from "./talent_bg5_image.png";
import talentBgImg6 from "./talent_bg6_image.png";
import talentBgImg7 from "./talent_bg7_image.png";
import talentBgImg8 from "./talent_bg8_image.png";
import talentBgImg9 from "./talent_bg9_image.png";
import talentBgImg10 from "./talent_bg10_image.png";
import talentBgImg11 from "./talent_bg11_image.png";
import talentBgImg12 from "./talent_bg12_image.png";
import EMERALDtonesImg from "./EMERALD.png";
import RUBYtonesImg from "./RUBY.png";
import SAPPHIREtonesImg from "./SAPPHIRE.png";
import DIAMONDtonesImg from "./DIAMOND.png";
import newlogo from "./logo_new.png";
const Image = {
  categoriesBanner,
  OriginativeImg,
  ourMissionImg,
  ourMissionmMobileImg,
  CategoriesBannerImg,
  gemlogoImg,
  bestQualityImg,
  userDashBoradBannerImg,
  userDashBoradBanner2Img,
  userDashBoradBanner3Img,
  talentBgImg1,
  talentBgImg2,
  talentBgImg3,
  talentBgImg4,
  talentBgImg5,
  talentBgImg6,
  talentBgImg7,
  talentBgImg8,
  talentBgImg9,
  talentBgImg10,
  talentBgImg11,
  talentBgImg12,
  DIAMONDtonesImg,
  EMERALDtonesImg,
  RUBYtonesImg,
  SAPPHIREtonesImg,
  newlogo,
};
export default Image;
